module.exports = __webpack_public_path__ + "static/img/touch_light.8fabedf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/state-ui/touch_light.gif
// module id = oV+a
// module chunks = 1